const dialogHelper = () => {
  const dialogButtons = document.querySelectorAll('.reveal-modal-wrapper');
  const closeButtons = document.querySelectorAll('.close-dialog');

  if (!dialogButtons.length) return;

  dialogButtons.forEach((wrapper) => {
     wrapper.addEventListener('click', (e) => {
         const el = e.currentTarget;
         const target = document.getElementById(wrapper.dataset.target);

         if(target) {
             target.showModal();
         }
     });
  });

  closeButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
          const el = e.currentTarget;
          el.closest('dialog').close();
      });
  });
};

export default dialogHelper;